import { IFormField, IFormSection } from "../web-form.objects"
import _ from "lodash";

export class DateInputOptions {
    constructor() {

    }
}

export class DateInputField implements IFormField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    formSection: IFormSection;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    options: DateInputOptions;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, options: DateInputOptions = new DateInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.options = options;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection

        this.initializeSectionUpdateTrigger();
    }

    private initializeSectionUpdateTrigger() {
        $(`#${this.fieldId}`).on("change", () => {
            this.triggerSectionUpdate();
        });
    }

    private getInput(): string {
        let input = <string>$(`#${this.fieldId}`).val();
        return input;
    }

    private setInput(data: any): void {
        let dateVal = new Date(data);
        let formattedVal = dateVal.toISOString().split("T")[0];
        // Don't populate if its default year (year 1)
        if (dateVal.getFullYear() > 2000) {
            $(`#${this.fieldId}`).val(formattedVal);
        }
    }

    private getParsedInput() {
        let val = this.defaultVal;

        let input = this.getInput();
        if (input) {
            val = input;
        }

        return val;
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getInput();

        if (this.isRequired) {
            // empty or spaces
            if (!val) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.defaultVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}

